import type { FeatureProvider } from '..';

import AU from './AU.json';
import HK from './HK.json';
import ID from './ID.json';
import MY from './MY.json';
import NZ from './NZ.json';
import PH from './PH.json';
import SG from './SG.json';
import TH from './TH.json';

export const applyCountry: FeatureProvider =
  ({ country }) =>
  (featureInput) => {
    switch (country) {
      case 'AU':
        return { ...featureInput, ...AU };
      case 'ID':
        return { ...featureInput, ...ID };
      case 'MY':
        return { ...featureInput, ...MY };
      case 'NZ':
        return { ...featureInput, ...NZ };
      case 'PH':
        return { ...featureInput, ...PH };
      case 'SG':
        return { ...featureInput, ...SG };
      case 'TH':
        return { ...featureInput, ...TH };
      case 'HK':
        return { ...featureInput, ...HK };
      default:
        return featureInput;
    }
  };
